import { motion } from "framer-motion";

const MOSAIC =
    "https://static.wixstatic.com/media/d92b8c_2a1a3ba40f2344daa7201458da15291c~mv2.jpg/v1/fill/w_2200,h_1200,al_c,q_85,enc_auto/sunflower_mosaic.jpg";

export default function About() {
    return (
        <section
            id="experience"
            className="section-py container-px bg-background"
            data-testid="about-section"
        >
            <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true, margin: "-100px" }}
                    className="lg:col-span-5"
                >
                    <p className="overline">The López Experience</p>
                    <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                        A hacienda devoted to <em className="italic text-[hsl(var(--primary))]">art</em>, light
                        and the long Texas evening.
                    </h2>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.9, delay: 0.15 }}
                    viewport={{ once: true, margin: "-100px" }}
                    className="lg:col-span-7 space-y-8 text-muted-foreground text-lg leading-relaxed font-light"
                >
                    <p>
                        At the centre of López Hill lies a Michelangelo-inspired granite mosaic —
                        a vast, hand-laid courtyard that frames every ceremony with the gravity
                        of a masterpiece. Around it, the hacienda walls are alive with
                        multi-coloured tile after Vincent van Gogh, catching the long afternoon
                        light of the Texas Hill Country.
                    </p>
                    <p>
                        Beyond the courtyard you will find a working art gallery, a private
                        studio, and a small tequila room — a love letter to craft, to colour and
                        to the Mexican hospitality that defines the estate.
                    </p>

                    <div className="grid grid-cols-3 gap-8 pt-6 border-t border-border">
                        {[
                            { n: "100", l: "Seated guests" },
                            { n: "30 min", l: "From Austin" },
                            { n: "12 acres", l: "Hill Country" },
                        ].map((s) => (
                            <div key={s.l} data-testid={`stat-${s.l.toLowerCase().replace(/ /g, "-")}`}>
                                <div className="font-serif text-3xl sm:text-4xl text-foreground">
                                    {s.n}
                                </div>
                                <div className="overline mt-2">{s.l}</div>
                            </div>
                        ))}
                    </div>
                </motion.div>
            </div>

            <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
                viewport={{ once: true, margin: "-50px" }}
                className="mt-20 relative overflow-hidden"
            >
                <img
                    src={MOSAIC}
                    alt="Van Gogh-inspired mosaic detail at López Hill"
                    className="w-full h-[320px] sm:h-[480px] object-cover transition-transform duration-[1500ms] hover:scale-[1.02]"
                />
            </motion.div>
        </section>
    );
}
